<template>
  <div>
    <VTable class="managers-manager" :items="computedItems" :fields="fields" :checked-rows="checkedItems"
      :loading="loading" :on-toggle-row="onToggleRow" :on-input-search="onInputSearch" :on-edit-item="onEditItem"
      :on-delete-item="onDeleteItem" :on-click-to-add="onClickToAdd" searchPlaceholder="Search for blog title...." hover
      striped border small fixed dark>
      <template #footer>
        <VPagination :items-count="itemsCount" class="user-manager-card__footer-pagination" />
      </template>
    </VTable>
  </div>
</template>
<script>
import {
  auctionBannerStore,
  createAuctionBannerMixin,
} from "@/mixins/auctionBannerMixin";
import { debounce } from "@/utils/debounce";
import ModalType from '../utils/dictionaries/modalType';

export default {
  name: 'AuctionBanner',
  mixins: [createAuctionBannerMixin()],
  data() {
    return {
      title: '',
      content: '',
      isDisabled: false,
      loading: false,

      checkedItems: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "rowId", label: "" },
        { key: "title", label: "Title", _style: "max-width: 100px" },
        {
          key: "pageUrl",
          label: "Page Url",
          // _style: "min-width: 125px",
          // _classes: "blog-content"
        },
        { key: "action", _style: "max-width: 20px;min-width:20px" }
      ]
    },
    items() {
      return this[auctionBannerStore.getterTypes.GETTER_AUCTION_BANNERS];
    },
    itemsCount() {
      return this[auctionBannerStore.getterTypes.GETTER_AUCTION_BANNERS_COUNT];
    },
    computedItems() {
      return this.items && this.items.map(item => {
        return {
          ...item,
          // truncated_title: item.title.length > 100 ? item.title.substring(0, 100) + '...' : item.title,
          // truncated_content: item.content.length > 100 ? item.content.substring(0, 100) + '...' : item.content,
        }
      })
    }
  },

  watch: {
    $route() {
      this.loadData()
    }
  },

  async created() {
    await this.loadData()

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        }

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => { })
      },
      200
    )
  },
  methods: {
    onToggleRow(item) {
      // this.checkedItems = [item]
    },
    onInputSearch(t) {
      this.searchFn(t)
      console.log('onInputSearch', t)
    },
    onEditItem(item) {
      this.$modals.open(ModalType.AuctionBannerModal, item)
    },
    async onDeleteItem(item) {
      const deleteAction = async () => {
        try {
          const auctionBannerId = item.id
          this.$modals.close(ModalType.ConfirmationModal)
          await this[auctionBannerStore.actionTypes.ACTION_DELETE_AUCTION_BANNER]({ auctionBannerId })
        } catch (error) {
          console.log(error)
          console.log(error.response)
        }
      }
      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: `Are you sure you want to delete <strong>${item.title}</strong> blog?`,
        buttonText: 'Delete',
        onClickButton: deleteAction
      })
    },
    onClickToAdd() {
      this.$modals.open(ModalType.AuctionBannerModal, {})
    },
    async loadData() {
      this.loading = true;
      await this[auctionBannerStore.actionTypes.ACTION_LOAD_AUCTION_BANNERS]({
        skip: this.$route.query.skip || 0,
        take: this.$route.query.take || 10,
        search: this.$route.query.search || ''
      })
      this.loading = false
    },
  }
}
</script>
